import { jsx as r } from "react/jsx-runtime";
const e = ({
  size: t
}) => {
  switch (t) {
    case "sm":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M7.99915 7.16989L4.93248 10.2366L4.22998 9.53406L7.99915 5.76489L11.7683 9.53406L11.0658 10.2366L7.99915 7.16989Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M11.9987 10.7525L7.39872 15.3525L6.34497 14.2988L11.9987 8.64502L17.6525 14.2988L16.5987 15.3525L11.9987 10.7525Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M10.0014 8.96133L6.1681 12.7947L5.28998 11.9165L10.0014 7.20508L14.7129 11.9165L13.8348 12.7947L10.0014 8.96133Z",
          fill: "currentColor"
        }
      );
  }
}, l = ({
  size: t
}) => {
  switch (t) {
    case "sm":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M8.00152 7.5267L4.93486 10.5934L3.87402 9.53253L8.00152 5.40503L12.129 9.53253L11.0682 10.5934L8.00152 7.5267Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M12.0012 11.2926L7.40125 15.8926L5.81 14.3014L12.0012 8.11011L18.1925 14.3014L16.6012 15.8926L12.0012 11.2926Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ r(
        "path",
        {
          d: "M9.9994 9.40697L6.16607 13.2403L4.84003 11.9143L9.9994 6.75488L15.1588 11.9143L13.8327 13.2403L9.9994 9.40697Z",
          fill: "currentColor"
        }
      );
  }
}, a = ({
  size: t = "md",
  weight: L = "default"
}) => {
  switch (L) {
    case "bold":
      return /* @__PURE__ */ r(l, { size: t });
    case "book":
    case "default":
      return /* @__PURE__ */ r(e, { size: t });
  }
};
export {
  a as default
};
//# sourceMappingURL=DIconCaretUp.js.map
